import styled from "styled-components";

export const Layout = styled.div`
display: flex;
max-width 375px;
// height: 80vh;
line-height: 1.2;
overflow:hidden;
border-radius: 10px;
align-items: center;
flex-direction: column;
background-color: #fff;
// letter-spaccing: 0.4rem;


@media(max-width:650px){
  // width: 70vw;
  // height: 60vh;
}

@media(max-width:960px){

  // height: 60vh;
}
@media(max-width:1000px){
  // width: 60vw;

}

`;

export const Wrapper = styled.div`
// height: 300px;
  img{
    // height:180px;
    width: 100%;
    object-fit: contain;
    border-top-left-radius:10px;
    border-top-right-radius:10px;

    @media(max-width:650px){
      // height:135px;
    }
    
    @media(max-width:960px){
      // height:180px;
    }
  }
`;

export const Description =styled.div`
padding: 25px;

position: relative;
text-align: center;
flex-direction: column;
justify-content: center;


@media(max-width:320px){
  padding: 22px;
}

@media(max-width:960px){
  padding: 20px;
}

@media(max-width:1000px){
  padding:18px;

}
`


export const Title=styled.h1`
font-size: 16px;
font-weight: bold;
margin-bottom: 10px;
`
export const Text=styled.h4`
font-size: 14px;
font-weight: 500;
opacity: 0.5;
margin-bottom: 20px;
// overflow-wrap: break-word;

@media(max-width:650px){
  font-size: 3vw;
}

@media(max-width:960px){
  font-size: 3vw;
}
@media(max-width:1000px){
  font-size: 2.2vw;
}

`

export const Contents=styled.div`
display: flex;
padding: 10px 20px;
border-radius: 10px;
justify-content: space-between;
background-color: rgb(240, 244, 247);

@media(max-width:320px){
  padding: 6px 16px;
}

@media(max-width:960px){
  // height:180px;
}
@media(max-width:1000px){
 
}

img{
  height: 35px;
  width: 35px;
  border-radius: 50%;
}

`

export const Pricing=styled.div`
@media(max-width:650px){
  font-size: 2vw;
}

@media(max-width:960px){
  font-size: 2vw;
}

@media(max-width:1000px){
  font-size: 2.2vw;
}
`

export const Name=styled.h4`
color: #000;
white-space: nowrap;


@media(max-width:650px){
  margin-right: 10px;
   white-space: nowrap;
}

@media(max-width:960px){
  white-space: nowrap;
}
`

export const Price=styled.h4`
opacity: 0.5;
font-size:12px;
font-weight: bold;

@media(max-width:650px){
  font-size: 12px;
}

@media(max-width:960px){
  font-size: 10px;
}

@media(max-width:1000px){
  font-size: 10px;
}
`

export const Change=styled.h5`
color: blue;
font-weight: bold;
cursor: pointer;
text-decoration: underline;

&:hover {
  color: #8250df;
  text-decoration: none;
}


@media(max-width:563px){
  font-size: 10px;
}

@media(max-width:960px){
  font-size: 8px;
}

@media(max-width:1000px){
  font-size: 8px;
}
`
// export const Submit=styled.div`
// cursor: pointer;
// margin-top: 20px;
// padding: 10px 30px;
// border-radius: 10px;
// background-color: blue;
// box-shadow:  0 3px 10px rgb(0 0 0 / 0.4);

// &:hover {
//   background-color: #8250df;
// }
// `
export const Button=styled.div`
color: #fff;
border: none;
font-weight: bold;
white-space: nowrap;
background-color: blue;
cursor: pointer;
margin-top: 20px;
padding: 10px 20px;
border-radius: 10px;
// background-color: blue;
box-shadow:  0 3px 10px rgb(0 0 0 / 0.4);


&:hover {
  background-color: #8250df;
}
`

export const Paymenttext=styled.h5`
opacity: 0.5;
cursor: pointer;
margin-top: 20px;
margin-bottom: 20px;

&:hover {
  color: #000;
  opacity: 1;
}
`